const API_URL = process.env.REACT_APP_API_URL

export const fetchServices = () => fetch(`${API_URL}/api/status`).then(response => response.json())
